import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=607669be&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('607669be')) {
      api.createRecord('607669be', component.options)
    } else {
      api.reload('607669be', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=607669be&", function () {
      api.rerender('607669be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2NabYmhaiHFcd/JS/offershelp.vue"
export default component.exports